<template>
  <BaseContainer
    class="dnnCloud-order-box"
    :loading="listLoading"
    :isHasPageFt="!listLoading"
  >
    <template v-slot:hd>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-input
              v-model="userName"
              placeholder="用户名"
              style="width: 180px"
              clearable
              @keyup.enter.native="getList()"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getList(1)"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </template>

    <template v-slot:main>
      <!--列表-->
      <el-table
        :data="dataList"
        highlight-current-row
        @selection-change="selsChange"
        :height="maxTbHeight"
        style="width: 100%"
        :header-cell-style="getRowClass"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="80"
        >
          <template slot-scope="scope">
            <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="userName"
          label="用户名"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.userId ? scope.row.userName : "-" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="company"
          label="企业"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.company || "-" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="membershipName"
          label="角色"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.membershipName ? scope.row.membershipName : "-"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="straightCurveFiles"
          label="直曲线PDF"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.straightCurveFiles &&
                scope.row.straightCurveFiles.length > 0
              "
              class="table-column-box"
            >
              <span class="table-column-text">{{
                scope.row.straightCurveFiles[0].fileTitle
              }}</span>
              <template v-if="scope.row.straightCurveFiles.length > 1">
                <el-popover placement="top-start" width="200" trigger="click">
                  <div
                    class="popover-item"
                    v-for="item in scope.row.straightCurveFiles"
                    :key="item.id"
                  >
                    <i class="dnnfont iconnormal"></i>
                    <span class="popover-item-text">{{ item.fileTitle }}</span>
                  </div>
                  <i
                    slot="reference"
                    class="dnnfont iconfolder-filled table-column-popover-icon"
                  ></i>
                </el-popover>
              </template>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="verticalCurveFiles"
          label="竖曲线PDF"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.verticalCurveFiles &&
                scope.row.verticalCurveFiles.length > 0
              "
              class="table-column-box"
            >
              <span class="table-column-text">
                {{ scope.row.verticalCurveFiles[0].fileTitle }}
              </span>
              <template v-if="scope.row.verticalCurveFiles.length > 1">
                <el-popover placement="top-start" width="200" trigger="click">
                  <div
                    class="popover-item"
                    v-for="item in scope.row.verticalCurveFiles"
                    :key="item.id"
                  >
                    <i class="dnnfont iconnormal"></i>
                    <span class="popover-item-text">{{ item.fileTitle }}</span>
                  </div>
                  <i
                    slot="reference"
                    class="dnnfont iconfolder-filled table-column-popover-icon"
                  ></i>
                </el-popover>
              </template>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="alignmentDiagramFiles"
          label="线位图"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.alignmentDiagramFiles &&
                scope.row.alignmentDiagramFiles.length > 0
              "
              class="table-column-box"
            >
              <span class="table-column-text">
                {{ scope.row.alignmentDiagramFiles[0].fileTitle }}
              </span>
              <template v-if="scope.row.alignmentDiagramFiles.length > 1">
                <el-popover placement="top-start" width="200" trigger="click">
                  <div
                    class="popover-item"
                    v-for="item in scope.row.alignmentDiagramFiles"
                    :key="item.id"
                  >
                    <i class="dnnfont iconnormal"></i>
                    <span class="popover-item-text">{{ item.fileTitle }}</span>
                  </div>
                  <i
                    slot="reference"
                    class="dnnfont iconfolder-filled table-column-popover-icon"
                  ></i>
                </el-popover>
              </template>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="jdFiles"
          label="转换JD文件"
          min-width="120"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.jdFiles && scope.row.jdFiles.length > 0"
              class="table-column-box"
            >
              <span class="table-column-text">
                {{ scope.row.jdFiles[0].fileTitle }}
              </span>
              <template v-if="scope.row.jdFiles.length > 1">
                <el-popover placement="top-start" width="200" trigger="click">
                  <div
                    class="popover-item"
                    v-for="item in scope.row.jdFiles"
                    :key="item.id"
                  >
                    <i class="dnnfont iconnormal"></i>
                    <span class="popover-item-text">{{ item.fileTitle }}</span>
                  </div>
                  <i
                    slot="reference"
                    class="dnnfont iconfolder-filled table-column-popover-icon"
                  ></i>
                </el-popover>
              </template>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="sqxFiles"
          label="转换SQX文件"
          min-width="120"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.sqxFiles && scope.row.sqxFiles.length > 0"
              class="table-column-box"
            >
              <span class="table-column-text">
                {{ scope.row.sqxFiles[0].fileTitle }}
              </span>
              <template v-if="scope.row.sqxFiles.length > 1">
                <el-popover placement="top-start" width="200" trigger="click">
                  <div
                    class="popover-item"
                    v-for="item in scope.row.sqxFiles"
                    :key="item.id"
                  >
                    <i class="dnnfont iconnormal"></i>
                    <span class="popover-item-text">{{ item.fileTitle }}</span>
                  </div>
                  <i
                    slot="reference"
                    class="dnnfont iconfolder-filled table-column-popover-icon"
                  ></i>
                </el-popover>
              </template>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="icdFiles"
          label="转换ICD文件"
          min-width="120"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.icdFiles && scope.row.icdFiles.length > 0"
              class="table-column-box"
            >
              <span class="table-column-text">
                {{ scope.row.icdFiles[0].fileTitle }}
              </span>
              <template v-if="scope.row.icdFiles.length > 1">
                <el-popover placement="top-start" width="200" trigger="click">
                  <div
                    class="popover-item"
                    v-for="item in scope.row.icdFiles"
                    :key="item.id"
                  >
                    <i class="dnnfont iconnormal"></i>
                    <span class="popover-item-text">{{ item.fileTitle }}</span>
                  </div>
                  <i
                    slot="reference"
                    class="dnnfont iconfolder-filled table-column-popover-icon"
                  ></i>
                </el-popover>
              </template>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="170"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span> {{ dateTran(scope.row.createTime) }} </span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          min-width="50"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <a href="#" @click.prevent="download(scope.row)">下载</a>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-slot:ft>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50, 100]"
          :current-page="pageNumber"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>
<script>
import { mapGetters } from "vuex";
import { API_AIPdf } from "../../../api/index.js";
import BaseContainer from "@/components/BaseContainer";
import fitTableHeight from "@/mixins/fitTableHeight.js";

import JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  mixins: [fitTableHeight],
  data() {
    return {
      disSouch: true,
      disType: false,
      disAccountType: false,
      disTime1: false,
      disTime2: false,
      token: "",
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      pageNumber: this.$route.query.pageNumber
        ? this.$route.query.pageNumber
        : 1,
      pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 20,
      total: 0,
      value: "",
      userName: "",
      searchText: this.$route.query.searchText,
      loginType: sessionStorage.getItem("type"),
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  components: {
    BaseContainer,
  },

  methods: {
    getList: function () {
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        userName: this.userName,
      };
      this.listLoading = true;
      API_AIPdf.getAIPdfList(param)
        .then((res) => {
          console.log(res);
          this.dataList = res.data.data.list;
          this.total = res.data.data.totalRow;
          this.listLoading = false;
        })
        .catch((err) => {
          this.$message.error("数据丢失，试试重新登陆！");
          this.listLoading = false;
        });
    },

    dateTran: function (timestamp) {
      const date = new Date(timestamp);

      // 获取年、月、日、小时、分钟、秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // 构建所需的格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },

    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function (sels) {
      this.sels = sels;
    },

    download: async function (row) {
      const zip = new JSZip();

      // 合并本条数据内所有文件
      const tempFiles = [
        ...(row.straightCurveFiles || []),
        ...(row.verticalCurveFiles || []),
        ...(row.alignmentDiagramFiles || []),
        ...(row.jdFiles || []),
        ...(row.sqxFiles || []),
        ...(row.icdFiles || []),
      ];
      const filesToDownload = tempFiles.map((file) => ({
        url: file.url,
        name: file.fileTitle,
      }));

      const validFiles = filesToDownload.filter((file) => file.url);

      if (validFiles.length === 0) {
        this.$message.warning("没有可下载的文件");
        return;
      }

      try {
        // 并行下载所有文件内容
        const downloadPromises = validFiles.map(async (file) => {
          const response = await fetch(file.url);
          if (!response.ok) throw new Error(`下载失败: ${file.name}`);
          const blob = await response.blob();
          zip.file(file.name, blob); // 添加到 ZIP
        });

        // 等待所有文件下载完成
        await Promise.all(downloadPromises);

        // 生成 ZIP 并下载
        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, "PDF平纵提取" + this.getDate() + ".zip");

        this.$message.success("文件打包成功！");
      } catch (error) {
        console.error("打包失败:", error);
        this.$message.error("打包失败，请重试");
      }
    },

    getDate: function () {
      const now = new Date();
      return (
        now.getFullYear() +
        "-" +
        String(now.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(now.getDate()).padStart(2, "0") +
        "_" +
        String(now.getHours()).padStart(2, "0") +
        "-" +
        String(now.getMinutes()).padStart(2, "0") +
        "-" +
        String(now.getSeconds()).padStart(2, "0")
      );
    },

    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
  },

  created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  },
};
</script>

<style lang="scss">
.dnnCloud-order-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
  .table-column-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .table-column-text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .table-column-popover-icon {
      cursor: pointer;
      margin-left: 5px;
    }
  }
}
</style>
<style scoped>
.el-select {
  display: inline-block;
  position: relative;
  width: 115px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.popover-item {
  margin: 8px 0;
}
.popover-item .dnnfont {
  color: #f66b3d;
}
</style>



// WEBPACK FOOTER //
// AIPdf.vue?60533026